"use client";

import { Button } from "@pandawa-qfast-core/react-ui-kit";
import Link from "next/link";

export function NotFoundSection({
  title,
  decorativeTitle,
  description,
}: {
  title: string;
  decorativeTitle?: string;
  description?: string;
}) {
  return (
    <>
      <div className="flex min-h-screen items-center justify-center bg-white p-6">
        <div className="max-w-md text-center">
          <h6 className="font-bold tracking-widest leading-[111%] mx-auto text-primary-600 mb-6">{decorativeTitle}</h6>

          <h1 className="mb-2 text-2xl font-bold">{title}</h1>
          <p className="text-muted-foreground">{description}</p>

          <div className="mt-6 flex items-center justify-center text-center">
            <Button className="font-bold" asChild>
              <Link href="/">Kembali</Link>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
